// extracted by mini-css-extract-plugin
export var flag = "CheckoutCountryCode-module--flag--3mRxE";
export var countryNumber = "CheckoutCountryCode-module--countryNumber--G24-Z";
export var container = "CheckoutCountryCode-module--container--2wjzx";